export default {
  sysTitle: "ซี.เอส.เอ็นเนอร์ยี่ซิสเต็ม",
  sysMenu: "ระบบ",
  currentPosition: "ตำแหน่งปัจจุบัน",
  operatorId: "รหัสผู้ประกอบการ",
  oprName: "ชื่อผู้ประกอบการ",
  tips: "เคล็ดลับ",
  isDelete: "คุณแน่ใจหรือว่าต้องการลบ",
  deleteSuccess: "ลบเรียบร้อยแล้ว",
  updateSuccess: "อัปเดตสำเร็จ",
  addSuccess: "เพิ่มสำเร็จ",
  all: "ทั้งหมด",
  operation: "การดำเนินการ",
  dl: "ปริมาณไฟฟ้า",
  eleFee: "ค่าไฟ",
  serverFee: "ค่าธรรมเนียมบริการ",
  delayFee: "ค่าล่วงเวลา",
  totalAmount: "จำนวนเงินทั้งหมด",
  yuan: "หยวน",
  kWh: "กิโลวัตต์ชั่วโมง",
  unitOrder: "เดี่ยว",
  ac: "เครื่องปรับอากาศ",
  dc: "กระแสตรง",
  confirm: "ยืนยัน",
  noData: "ไม่มีข้อมูล",
  allCity: "ทุกเมือง",
  chargingStation: "สถานีชาร์จ",
  merchant: "พ่อค้า",
  operator: "โอเปอเรเตอร์",
  chargingPile: "กองชาร์จ",
  year: "ปี",
  month: "เดือน",
  day: "วัน",
  timeType: "ประเภทเวลา",
  regularText: "ปกติ",
  irregular: "ไม่สม่ำเสมอ",
  disabled: "พิการ",
  operationSucess: "ความสำเร็จในการดำเนินงาน",
  saveSucess: "บันทึกสำเร็จ",
  exportSuccess: "นำเข้าสำเร็จ",
  allSelect: "ทั้งหมด เลือก",
  toExamine: "ตรวจสอบ",
  invalid: "ไม่ถูกต้อง",
  remark: "ข้อสังเกต",
  nothing: "ไม่มีอะไร",
  error: "ข้อผิดพลาด",
  connectionFailure: "การเชื่อมต่อล้มเหลว",
  notSupport: "เบราว์เซอร์ของคุณไม่รองรับ",
  keyword: "คำหลัก",
  reviewingMultipleRechargesForOneCard:
    "ตรวจสอบการเติมเงินหลายครั้งสำหรับบัตรใบเดียว",
  loadMore: "โหลดเพิ่มเติม",
  pleaseSelect: "โปรดเลือก",
  startSNPl: "กรุณาป้อน SN เริ่มต้น",
  endSNPl: "กรุณากรอก SN ต่อท้าย",
  must12Digits: "ต้องเป็น 12 หลัก",
  menuOperationAuthority: "สิทธิ์การใช้งานเมนู",
  audit: {
    approvalStatus: "สถานะการอนุมัติ",
    userName: "ชื่อผู้ใช้",
    phoneNo: "หมายเลขโทรศัพท์",
    applyTime: "เวลารับสมัคร",
    applyReason: "เหตุผลในการสมัคร",
    applyStatusDesc: "สถานะการอนุมัติ",
    auditTime: "เวลาตรวจสอบ",
    action: "ดำเนินงาน"
  },
  unitText: {
    pen: "ปากกา",
    yuan: "หยวน",
    hours: "ชั่วโมง",
    people: "ประชากร",
    seat: "ที่นั่ง",
    year: "ปี",
    month: "เดือน",
    day: "วัน",
    ton: "ตัน",
    second: "ที่สอง",
    full: "เต็ม",
    reduce: "ลด",
    give: "ให้",
    zhang: "จาง",
    individual: "รายบุคคล"
  },
  formText: {
    startTime: "เวลาเริ่มต้น",
    endTime: "เวลาสิ้นสุด",
    export: "ส่งออก",
    exportLoading: "กำลังโหลด...",
    exportNumber: "จำนวนการส่งออก",
    exportPl: "จำนวนการส่งออกต้องไม่น้อยกว่าหรือเท่ากับ 0",
    exportError: "ส่งออกผิดพลาดหรือหมดเวลา",
    allCity: "ทุกเมือง",
    selectGun: "ปืนชาร์จ",
    selectMch: "พ่อค้า",
    selectSite: "สถานีชาร์จ",
    selectPile: "กองชาร์จ",
    selectTime: "เลือกเวลา",
    selectTimePl: "กรุณาเลือกเวลา",
    selectOper: "ผู้ประกอบการ",
    downloadForm: "ดาวน์โหลดแบบฟอร์ม",
    intTips: "ตัวเลข",
    beginTimeTips: "กรุณาเลือกเวลาเริ่มต้น",
    endTimeTips: "กรุณาเลือกเวลาสิ้นสุด",
    import: "นำเข้า",
    selectProvince: "กรุณาเลือกจังหวัด",
    selectCity: "กรุณาเลือกเมือง",
    selectArea: "กรุณาเลือกพื้นที่",
    subSuccess: "การดำเนินการสำเร็จ",
    goBack: "กลับไป",
    timeNull: "กรุณาเลือกเวลา",
    timeMax: "เวลาเริ่มต้นต้องไม่เกินเวลาสิ้นสุด",
    time24: "24 ชั่วโมง",
    time7: "7 วัน",
    time30: "30 วัน",
    timeCustom: "กำหนดเอง",
    uploadError: "โปรดอัปโหลดประเภทไฟล์ต่อไปนี้:",
    copySuccess: "คัดลอกสำเร็จ",
    loginTimeOut: "การเข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
  },
  directCurrent: "กระแสตรง",
  alternatingCurrent: "เครื่องปรับอากาศ",
  gunStatus: "สถานะปืน",
  gunStatusObj: {
    onLine: "ในบรรทัด",
    offLine: "ออฟไลน์",
    free: "ฟรี",
    connected: "เชื่อมต่อ",
    charging: "กำลังชาร์จ",
    full: "เต็ม",
    trouble: "ปัญหา",
    disabled: "พิการ",
    booked: "จองแล้ว"
  },
  search: "ค้นหา",
  updata: "แก้ไข",
  update: "แก้ไข",
  add: "เพิ่ม",
  edit: "แก้ไข",
  delete: "ลบ",
  allDel: "การลบแบทช์",
  close: "ปิด",
  save: "บันทึก",
  refresh: "รีเฟรช",
  back: "กลับไป",
  export: "ส่งออก",
  import: "นำเข้า",
  submit: "ส่ง",
  cancel: "ยกเลิก",
  details: "รายละเอียด",
  query: "เช็ค",
  sure: "แน่นอน",
  copy: "คัดลอก",
  regular: {
    name: "ชื่อ",
    please: "กรุณาป้อนข้อมูล",
    pleaseSelect: "โปรดเลือก",
    max: "ไม่เกิน",
    maxText: "ตัวละคร",
    min: "ไม่น้อยกว่า",
    numberABC: "สามารถประกอบด้วยตัวเลขหรือตัวอักษรเท่านั้น",
    numberABCs: "สามารถประกอบด้วยตัวเลข ตัวอักษร และขีดล่างเท่านั้น",
    tel: "กรุณากรอกเบอร์มือถือหรือเบอร์โทรศัพท์ 6-15 หลัก",
    phone: "กรุณากรอกหมายเลขโทรศัพท์",
    phonePl: "กรุณาใส่หมายเลขโทรศัพท์มือถือ",
    phonePl11: "กรุณากรอกหมายเลขโทรศัพท์มือถือ 11 หลัก",
    phoneError: "กรุณาใส่หมายเลขโทรศัพท์มือถือที่ถูกต้อง",
    int: "เป็นเลขจำนวนเต็มได้เท่านั้น",
    maxInput: "อินพุตสูงสุด",
    minInput: "อินพุตขั้นต่ำ",
    unit: "",
    maxNum: "ไม่สามารถมากกว่า",
    minNum: "ไม่น้อยกว่า",
    money: "จำนวนเงิน",
    towDecimal: "เก็บทศนิยมไม่เกินสองตำแหน่ง",
    email: "กรุณาใส่อีเมล",
    emailPl: "กล่องจดหมายต้องไม่เกิน",
    emailError: "กรุณากรอกอีเมล์ให้ถูกต้อง"
  },
  login: {
    loginTitle: "ซี.เอส.เอ็นเนอร์ยี่ซิสเต็ม",
    userName: "ชื่อผู้ใช้",
    password: "รหัสผ่าน",
    loginBtn: "เข้าสู่ระบบ",
    userNamePl: "ป้อนชื่อผู้ใช้หนึ่งชื่อ",
    passwordPl: "กรุณาใส่รหัสผ่าน",
    passwordError: "กรุณาใส่รหัสผ่านที่มีมากกว่า 6 หลัก"
  },
  role: {
    roleList: "รายการบทบาท",
    autoMenu: "เมนู",
    autoConfig: "กำหนดค่าสิทธิ์",
    roleName: "ชื่ออักษรจีน",
    thRoleName: "ชื่อบทบาท",
    enRoleName: "ชื่อบทบาทภาษาอังกฤษ",
    roleType: "ประเภทบทบาท",
    roleDesc: "หมายเหตุ",
    createUserName: "ผู้สร้าง",
    createTime: "เวลาในการสร้าง",
    modifyTime: "เวลาอัปเดต",
    addRole: "เพิ่มบทบาท",
    upRole: "ปรับเปลี่ยนบทบาท",
    roleTypePl: "โปรดเลือกประเภทบทบาท",
    moduleName: "โมดูลเมนู",
    checkRender: "รายการอนุญาต"
  },
  user: {
    userManagement: "การจัดการผู้ใช้",
    globalSearch: "ป้อนคำค้นหา (ชื่อผู้ใช้ / บทบาท / ผู้สร้าง)",
    system: "ระบบ",
    resetPassword: "รีเซ็ตรหัสผ่าน",
    userName: "ชื่อผู้ใช้",
    fullName: "ชื่อเต็ม",
    phone: "โทรศัพท์",
    objectName: "โอเปอเรเตอร์",
    delUserConfirm: "คุณแน่ใจหรือที่จะลบผู้ใช้ที่เลือก?",
    addUser: "เพิ่มผู้ใช้",
    upUser: "แก้ไขผู้ใช้",
    info: "ข้อมูลที่จำเป็น",
    userPwd: "รหัสผ่าน",
    confirmPassword: "ยืนยันรหัสผ่าน",
    userPwdNull: "กรุณาใส่รหัสผ่าน",
    userPwdMin: "ความยาวรหัสผ่านคือ 18 ~ 6 ตัวอักษร",
    userPwdError: "รหัสผ่านต้องไม่มีช่องว่าง แท็บ หรือตัวแบ่งบรรทัด",
    userPwdTowError: "โปรดยืนยันว่ารหัสผ่านเก่าและใหม่ตรงกันหรือไม่",
    queryUser: "ดูผู้ใช้",
    userRolePl: "กรุณาเลือกบทบาท",
    newPassword: "รหัสผ่านใหม่"
  },
  log: {
    tab1: "บันทึกการทำงาน",
    tab2: "บันทึกการเข้าสู่ระบบ",
    loginIp: "IP เข้าสู่ระบบ",
    loginTime: "เวลาเข้าสู่ระบบ",
    resultDesc: "รายละเอียดการดำเนินงาน",
    logGlobalSearch: "ป้อนคำค้นหา (ชื่อผู้ใช้, IP เข้าสู่ระบบ)",
    operationLogGlobalSearch:
      "ป้อนคำค้นหา (ชื่อผู้ใช้ / ชื่อโมดูล / วิธีการดำเนินการ / IP ไคลเอนต์)",
    requestIp: "IP ของลูกค้า",
    moduleName: "ชื่อโมดูล",
    methodDesc: "วิธีการใช้งาน",
    operatorTime: "เวลาดำเนินการ",
    responseCode: "รายละเอียดการดำเนินงาน"
  },
  onlineuser: {
    globalSearch: "กรุณาใส่คำหลัก (ชื่อผู้ใช้ / เข้าสู่ระบบ / ที่อยู่ IP)",
    offline: "บังคับออฟไลน์",
    offlineConfirm: "คุณแน่ใจหรือไม่ว่าต้องการบังคับให้ออกจากระบบ",
    userFullName: "ชื่อบทบาท",
    ipAddress: "ที่อยู่ IP",
    loginTime: "เวลาเข้าสู่ระบบ"
  },
  dictionary: {
    globalSearch: "ป้อนคำค้นหา (ชื่อพจนานุกรม)",
    add: "รายการภาคผนวก",
    updata: "แก้ไขรายการ",
    items: "รายการ",
    child: "เด็ก",
    read: "อ่านเท่านั้น",
    addOp: "การดำเนินการทั้งหมด",
    edit: "แก้ไข",
    typeName: "ชื่อพจนานุกรม",
    typePkId: "ค่าคีย์",
    itemList: "รายการตาราง Canonical",
    typeFlag: "สถานะรายการที่เป็นที่ยอมรับ",
    typeFlagPl: "โปรดเลือกสถานะรายการตาราง",
    remark: "ข้อสังเกต",
    modifyTime: "เวลาอัปเดต",
    itemsManage: "การจัดการรายการ",
    childGlobalSearch: "ป้อนคำค้นหา (ชื่อรายการ)",
    rise: "ลุกขึ้น",
    decline: "ปฏิเสธ",
    itemValue: "ชื่อรายการ",
    englishName: "ชื่อรายการภาษาอังกฤษ",
    thName: "รายการ ชื่อภาษาไทย",
    itemKey: "สำคัญ",
    itemKeyPl: "กรุณาเลือกคีย์",
    flag: "สถานะ",
    normal: "ปกติ",
    disable: "ปิดการใช้งาน"
  },
  systemNotice: {
    add: "เพิ่มการอัพเกรดระบบ",
    upgradeContent: "เนื้อหาการอัพเกรดระบบ",
    upgradeTime: "เวลาอัพเกรดระบบ",
    version: "รุ่น",
    versionPl: "โปรดป้อนหมายเลขเวอร์ชัน",
    upgradeContentPl: "โปรดป้อนเนื้อหาการอัปเกรดระบบ",
    upgradeTimePl: "กรุณาเลือกเวลาอัพเกรดระบบ",
    updata: "แก้ไขอัพเกรดระบบ"
  },
  modelFile: {
    add: "เพิ่มไฟล์เทมเพลต",
    templateFile: "ไฟล์เทมเพลต",
    fileName: "ชื่อไฟล์",
    pkid: "คีย์หลักของไฟล์",
    createUserId: "ผู้สร้าง",
    createTime: "เวลาในการสร้าง",
    attachmentPkId: "คีย์หลักของไฟล์แนบ",
    modifyUserId: "ตัวดัดแปลง",
    modifyTime: "เวลาแก้ไข",
    businessType: "ประเภทธุรกิจ",
    fileType: "ประเภทไฟล์",
    templatePkId: "คีย์หลักของเทมเพลตไฟล์",
    attachmentPkIdPl: "โปรดอัปโหลดไฟล์เทมเพลต",
    businessTypePl: "กรุณาระบุประเภทธุรกิจ",
    fileNamePl: "กรุณาใส่ชื่อไฟล์",
    fileTypePl: "กรุณาเลือกประเภทไฟล์",
    remarkPl: "กรุณาใส่ความคิดเห็น",
    updata: "แก้ไขไฟล์เทมเพลต",
    lang: "ภาษา",
    langPl: "กรุณาเลือกภาษา"
  },
  menuList: {
    roleType: "ระบบ",
    child: "เด็ก",
    moduleName: "ชื่อเมนู",
    englishName: "ชื่อเมนูภาษาอังกฤษ",
    thailandName: "ชื่อเมนูภาษาไทย",
    privilegeVoList: "สิทธิพิเศษ",
    icon: "ไอคอน",
    sort: "เรียงลำดับ",
    url: "ลิงค์",
    activeMenu: "เมนูที่ใช้งานอยู่",
    hidden: "ที่ซ่อนอยู่",
    cacheName: "ชื่อแคช",
    alwaysShow: "แสดงเสมอ",
    component: "ส่วนประกอบ",
    yes: "ใช่",
    no: "เลขที่",
    componentPl: "กรุณากรอกส่วนประกอบ",
    cacheNamePl: "กรุณากรอกชื่อแคช",
    moduleNamePl: "กรุณาใส่ชื่อ",
    englishNamePl: "กรุณาใส่ชื่อภาษาอังกฤษของคุณ",
    thailandNamePl: "กรุณากรอกชื่อเมนูเป็นภาษาไทย",
    urlPl: "กรุณาใส่ลิงค์",
    addChild: "เพิ่มเมนูย่อย",
    updata: "แก้ไขเมนูย่อย",
    add: "เพิ่มเมนู",
    auto: "เลือกสิทธิพิเศษ",
    addAuto: "เพิ่มสิทธิพิเศษ",
    privilegePl: "กรุณาเลือกสิทธิ์"
  },
  stopReason: {
    allConfig: "การตั้งค่าแบทช์",
    add: "เพิ่มเหตุผลการหยุด",
    stopCode: "รหัสหยุด",
    stopName: "หยุดเหตุผล",
    duty: "การกระจายความรับผิดชอบ",
    addRow: "เพิ่มแถว",
    updata: "แก้ไขเหตุผลการหยุด",
    stopCodePl: "กรุณาใส่รหัสหยุด",
    stopNamePl: "กรุณาใส่ชื่อหยุด",
    responsibilityTypePl: "โปรดเลือกการมอบหมายความรับผิดชอบ",
    configDataPl: "โปรดเลือกข้อมูลที่จะกำหนดค่า",
    configSuccess: "กำหนดค่าสำเร็จ",
    responsibilityType: "การกระจายความรับผิดชอบ"
  },
  alarmSet: {
    allConfig: "การตั้งค่าแบทช์",
    add: "เพิ่มการกำหนดค่าการเตือนภัย",
    updata: "แก้ไขการกำหนดค่าการเตือน",
    alarmLevel: "ระดับการเตือนภัย",
    alarmType: "ประเภทการแจ้งเตือน",
    faultName: "ชื่อความผิด",
    faultCode: "รหัสข้อผิดพลาด",
    faultTipMsg: "ข้อมูลแจ้งผู้ใช้",
    type: "ประเภทการแจ้งเตือน",
    addRow: "เพิ่มบรรทัด",
    faultCodePl: "กรุณากรอกรหัสข้อผิดพลาด",
    faultTipMsgPl: "โปรดป้อนข้อมูลแจ้งผู้ใช้",
    alarmLevelPl: "กรุณาเลือกระดับการเตือน",
    alarmTypePl: "กรุณาเลือกประเภทการแจ้งเตือน",
    configDataPl: "โปรดเลือกข้อมูลที่จะกำหนดค่า",
    configSuccess: "กำหนดค่าสำเร็จ",
    solution: "สารละลาย",
    solutionPl: "โปรดป้อนวิธีแก้ปัญหา",
    faultNamePl: "กรุณาใส่ชื่อข้อผิดพลาด",
    faultEnName: "ชื่อภาษาอังกฤษผิด",
    faultEnNamePl: "กรุณากรอกชื่อภาษาอังกฤษ",
    faultTipEnMsg: "พร้อมชื่อภาษาอังกฤษ",
    faultTipEnMsgPl: "โปรดป้อนข้อมูลแจ้งผู้ใช้เป็นภาษาอังกฤษ"
  },
  kafkaLog: {
    globalSearch: "ป้อนคำค้นหา (หัวข้อ)",
    partition: "พาร์ทิชัน",
    createTime: "เวลาในการสร้าง",
    startOffset: "ชดเชยขั้นต่ำ",
    endOffset: "ชดเชยสูงสุด",
    consumption: "การบริโภค",
    allConsumption: "การบริโภคซ้ำจำนวนมาก",
    allConsumptionConfirm:
      "คุณแน่ใจหรือไม่ว่าต้องการบริโภครายการที่เลือกอีกครั้ง",
    allDel: "การลบแบทช์",
    allDelConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการที่เลือก",
    topic: "หัวข้อ",
    topicInfo: "การบริโภคข้อมูลหัวข้อ",
    requestParam: "ขอพารามิเตอร์",
    reason: "ข้อความผิดพลาด"
  },
  orderConfig: {
    allOpen: "เปิดแบทช์",
    allOpenConfirm: "คุณแน่ใจหรือไม่ว่าต้องการเปิดแบทช์ที่เลือกไว้",
    allClose: "ปิดแบทช์",
    allCloseConfirm: "คุณแน่ใจหรือไม่ว่าต้องการปิดรายการที่เลือกเป็นกลุ่ม",
    open: "เปิดใช้งาน",
    close: "ปิด",
    enabled: "เปิดใช้งานการยืนยันหรือไม่",
    faultName: "ชื่อผิด",
    faultCode: "รหัสข้อผิดพลาด",
    faultDesc: "สรุปข้อผิดพลาด",
    faultTypeDesc: "คำอธิบายประเภทข้อผิดพลาด"
  },
  alarmsetting: {
    tab1: "การตั้งค่าชุดการเตือนอุปกรณ์",
    tab2: "การตั้งค่าการเตือนอุปกรณ์ทีละรายการ",
    tab3: "การตั้งค่าการแจ้งเตือนการจราจรของซิม",
    set: "ติดตั้ง",
    alarmLevel: "ระดับการเตือนภัย",
    faultCode: "รหัสข้อผิดพลาด",
    faultName: "คำอธิบายข้อบกพร่อง",
    flow: "เกณฑ์การไหล",
    setLevel: "ตั้งระดับการเตือน",
    alarmLevelName: "ระดับการเตือนภัย"
  },
  ratamanage: {
    tab1: "เทมเพลตอัตราของระบบ",
    tab2: "เทมเพลตอัตราผู้ให้บริการ",
    templateName: "ชื่อแม่แบบ",
    updateTime: "เวลาอัปเดต",
    jian: "คม",
    feng: "จุดสูงสุด",
    ping: "แบน",
    gu: "หุบเขา",
    acRate: "อัตราการชาร์จ AC กอง",
    dcRate: "อัตราการชาร์จ DC กอง",
    delayRate: "อัตราค่าธรรมเนียมล่าช้า",
    bindStaNum: "ปริมาณการใช้งาน",
    modifyTime: "เวลาในการสร้าง",
    rateDetails: "รายละเอียดอัตรา",
    delayRateDetails: "รายละเอียดอัตราค่าธรรมเนียมล่าช้า",
    slotDelayPrice: "อัตรา (หยวน/นาที)",
    ent: "องค์กร",
    bindSta: "เว็บไซต์พันธมิตร",
    stationName: "ชื่อไซต์",
    stationAddress: "ที่อยู่ไซต์",
    index: "หมายเลขซีเรียล"
  },
  addRatamanage: {
    feeName: "ชื่อแม่แบบ",
    rate: "อัตราการชาร์จ",
    delayFreeMinutes: "เวลาว่าง (นาที)",
    add: "เพิ่มเทมเพลตอัตราของระบบ",
    addOper: "เพิ่มเทมเพลตอัตราของผู้ให้บริการ",
    feeNamePl: "กรุณาใส่ชื่อแม่แบบ",
    acRate: "อัตราเสาเข็ม AC",
    dcRate: "อัตราเสาเข็ม DC",
    delayRate: "อัตราค่าธรรมเนียมล่าช้า",
    slotFlag: "ประเภทราคาไฟฟ้า",
    slotElecPrice: "ค่าไฟฟ้า (หยวน)",
    slotServicePrice: "ค่าบริการ (หยวน/กิโลวัตต์ชั่วโมง)",
    timeValue: "ระยะเวลา",
    pricePl: "กรุณาใส่ตัวเลขสำหรับราคา",
    priceMax: "ราคาปัจจุบันต้องไม่เกิน",
    selectTimePl: "โปรดเลือกเวลาที่จะเพิ่ม",
    timeNoSelect: "เลือก 24 ชั่วโมงทั้งหมดแล้วและไม่สามารถเพิ่มได้",
    timeError: "ช่วงเวลาเหลื่อมกัน โปรดตรวจสอบ",
    timeNoSelectSuccess: "กรุณาเลือกเต็ม 24 ชั่วโมง",
    slotElecPriceMax: "ค่าไฟฟ้าไม่เกินราคา",
    slotServicePriceMax: "ราคาค่าบริการต้องไม่เกิน",
    please: "กรุณาป้อน",
    slotDelayPrice: "อัตรา (หยวน/นาที)"
  },
  equipmentModel: {
    deviceType: "ประเภทอุปกรณ์",
    updateTime: "เวลาอัปเดต",
    globalSearch: "รุ่นอุปกรณ์/ผู้ผลิต",
    deviceModelName: "รุ่นอุปกรณ์",
    addSn: "ช่วงเวลา SN ของอุปกรณ์",
    number: "ปริมาณ",
    standard: "ข้อมูลมาตรฐาน",
    matching: "ข้อมูลทางเลือก",
    manufacturerName: "ผู้ผลิต",
    delDeviceModelName: "คุณแน่ใจหรือไม่ว่าต้องการลบรุ่นอุปกรณ์ที่เลือก",
    minSelectItem: "โปรดเลือกอย่างน้อยหนึ่งรายการ",
    factoryInfo: "ข้อมูลผู้ผลิต",
    manufacturerPkId: "ชื่อผู้ผลิต",
    matchingAdd: "ตัวเลือกเพิ่มเติม",
    optionName: "ชื่อตัวเลือก",
    remark: "คำอธิบายตัวเลือก",
    addDeviceModel: "เพิ่มรุ่นอุปกรณ์",
    deviceModelNamePl: "กรุณากรอกรุ่นอุปกรณ์",
    manufacturerPkIdPl: "กรุณาเลือกชื่อผู้ผลิต",
    optionNamePl: "กรุณาใส่ชื่อตัวเลือก",
    isChecked: "ได้มาตรฐานไหม",
    optionValue: "ค่าคงที่",
    deviceModelDetails: "รายละเอียดรุ่นอุปกรณ์",
    updataDeviceModel: "แก้ไขรุ่นอุปกรณ์",
    optionValueError: "ค่าคงที่ของรายการมาตรฐานที่เลือกต้องไม่ว่างเปล่า",
    deviceTypeInfo: "ข้อมูลรุ่น",
    deviceTypePl: "กรุณาเลือกประเภทอุปกรณ์",
    deviceModelPkIdPl: "กรุณาเลือกรุ่นอุปกรณ์",
    optionEnName: "ชื่อภาษาอังกฤษ",
    optionEnNamePl: "กรุณากรอกชื่อภาษาอังกฤษ",
    remarkEn: "คำอธิบายตัวเลือกภาษาอังกฤษ",
    remarkEnPl: "โปรดป้อนคำอธิบายตัวเลือกภาษาอังกฤษ"
  },
  equipmentList: {
    sns: "SN อุปกรณ์",
    snsPl: "sn หลายรายการคั่นด้วยเครื่องหมายจุลภาค",
    allSns: "ชุด",
    isBindOper: "สถานะไฟล์แนบ",
    projectName: "โครงการแสดงที่มา",
    maintenanceMethodsType: "วิธีการบำรุงรักษา",
    export: "อุปกรณ์นำเข้า",
    add: "เพิ่มอุปกรณ์",
    relation: "ความสัมพันธ์",
    disassociate: "ยกเลิกการเชื่อมโยง",
    disassociateConfrim:
      "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเชื่อมโยงอุปกรณ์ที่เลือก",
    delConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบอุปกรณ์ที่เลือก",
    unattached: "ไม่ได้แนบ",
    attached: "ที่แนบมา",
    serialNumber: "SN อุปกรณ์",
    gunNum: "ปากกระบอกปืนนับ",
    belongInfo: "ข้อมูลเอกสารแนบ",
    import: "เลือกไฟล์นำเข้า",
    importTpl: "นำเข้าแม่แบบ",
    importTplDownload: "ดาวน์โหลดเทมเพลตนำเข้า",
    total: "รวมเวลานี้",
    dev: "อุปกรณ์",
    dc: "กระแสตรง",
    ac: "ไฟฟ้ากระแสสลับ",
    protocolPkId: "มาตรการ",
    protocolPkIdPl: "กรุณาเลือกข้อตกลง",
    detailsTitle: "รายละเอียดอุปกรณ์",
    dataDetails: "รายละเอียดพารามิเตอร์",
    manufacturerName: "ผู้ผลิต",
    typeNumber: "หมายเลขรุ่นของอุปกรณ์",
    changeModel: "เปลี่ยนรุ่น",
    bindDev: "อุปกรณ์ที่เกี่ยวข้อง",
    unBindDev: "อุปกรณ์ที่จะเชื่อมโยง",
    changeOper: "เปลี่ยนผู้ให้บริการ",
    noChangeOper: "อุปกรณ์ที่ต้องเปลี่ยน",
    bindOper: "ผู้ประกอบการในเครือ",
    operPl: "โปรดเลือกผู้ให้บริการ",
    deviceModelPl: "กรุณาเลือกอุปกรณ์",
    addSn: "ช่วงเวลา SN ของอุปกรณ์",
    quantity: "ปริมาณ",
    addBtn: "เพิ่ม",
    snNull: "SN ของอุปกรณ์ต้องไม่ว่างเปล่า",
    snInt: "SN ของอุปกรณ์ต้องเป็นตัวเลข",
    // 修改密码
    editPwd: "เปลี่ยนรหัสผ่าน",
    selectStation1: "เลือกสถานีชาร์จไฟ ",
    selectStation2: " แห่งแล้ว",
    customPassword: " รหัสผ่านที่กำหนดเอง",
    customPasswordTip: "ตั้งรหัสผ่านเดียวกันสำหรับสถานีชาร์จไฟที่เลือก",
    randomPassword: "รหัสผ่านแบบสุ่ม",
    randomPasswordTip:
      "สร้างรหัสผ่านแบบสุ่ม 6 หลักสำหรับสถานีชาร์จแต่ละสถานีโดยอัตโนมัติ",
    pwdPl: "กรุณาป้อนรหัสผ่านตัวเลข 4-8 หลัก",
    pwdSucc: "ดำเนินการเรียบร้อยแล้ว โปรดรอ 3 นาทีก่อนที่จะตรวจสอบผลลัพธ์",
    passwordModificationRecord: "ประวัติการแก้ไขรหัสผ่าน (ล่าสุด 5)",
    currentPassword: "รหัสผ่านปัจจุบัน",
    password: "รหัสผ่าน",
    updateTime: "อัปเดตเวลา",
    status: "สถานะ",
    lastSuccessful: "ครั้งล่าสุดที่เปลี่ยนรหัสผ่านสำเร็จ"
  },
  producer: {
    busLicenseNumber: "เลขที่ใบประกอบการ",
    brandName: "ชื่อแบรนด์",
    manufacturerName: "ผู้ผลิตอุปกรณ์",
    manufacturerId: "รหัสองค์กรผู้ผลิตอุปกรณ์",
    contactName: "ติดต่อ",
    phoneNo: "โทรศัพท์",
    legalPerson: "ขององค์กร",
    legalIdCard: "รหัสนิติบุคคล",
    busLicenseNumberPl: "กรุณากรอกเลขที่ใบประกอบการ",
    busLicenseNumberMax: "ความยาวของหมายเลขใบอนุญาตธุรกิจคือ 18 หลัก",
    brandNamePl: "กรุณาใส่ชื่อแบรนด์",
    manufacturerNamePl: "โปรดป้อนผู้ผลิตอุปกรณ์",
    manufacturerIdPl: "โปรดป้อนรหัสองค์กรผู้ผลิตอุปกรณ์",
    manufacturerIdMax: "ความยาวของหมายเลขใบอนุญาตธุรกิจคือเก้าหลัก",
    legalPersonPl: "กรุณากรอกนิติบุคคลของบริษัท",
    legalIdCardPl: "กรุณากรอก ID นิติบุคคล",
    legalIdCardMax: "ความยาวของบัตรประจำตัวนิติบุคคลคือ 18 ตัวอักษร",
    contactNamePl: "กรุณากรอกรายชื่อผู้ติดต่อ",
    add: "เพิ่มผู้ผลิตอุปกรณ์",
    updata: "แก้ไขผู้ผลิตอุปกรณ์"
  },
  oper: {
    101: "เทมเพลต SMS เข้าสู่ระบบ",
    102: "แก้ไขเทมเพลตรหัสผ่าน",
    103: "เทมเพลตการเปลี่ยนแปลงข้อมูล",
    104: "เทมเพลตการรับรองความถูกต้อง",
    201: "การแจ้งเตือนการเริ่มชาร์จ",
    202: "แจ้งการชำระค่าธรรมเนียม",
    203: "การแจ้งเตือนการสิ้นสุดการชาร์จ",
    204: "การแจ้งเตือนยอดเงินไม่เพียงพอ",
    301: "การแจ้งเตือนความล้มเหลว",
    operData: "จำนวนผู้ประกอบการ",
    operTotal: "จำนวนผู้ประกอบการทั้งหมด",
    accData: "การวิเคราะห์การหมดอายุของบัญชี",
    globalSearch: "ป้อนคำค้นหา (ชื่อผู้ประกอบการ/ตัวย่อผู้ประกอบการ)",
    oprStatus: "สถานะการดำเนินงาน",
    expireDays: "วันหมดอายุ",
    customMade: "ทำเอง",
    msgConfig: "การกำหนดค่า SMS",
    phoneConfig: "การกำหนดค่าแบบกำหนดเอง",
    functionalConfig: "การกำหนดค่าการทำงาน",
    gunLimit: "ขีดจำกัดปากปืน",
    invoice: "ใบแจ้งหนี้",
    carInfo: "ข้อมูลยานพาหนะ",
    customizedChargingStrategy: "กลยุทธ์การชาร์จที่ปรับให้เหมาะสม",
    day30: "ครบกำหนด 30 วัน",
    day60: "ครบกำหนด 60 วัน",
    day90: "ครบกำหนด 90 วัน",
    companyName: "ชื่อสั้น",
    userName: "ผู้ดูแลระบบ",
    deviceCount: "ปริมาณอุปกรณ์",
    createTime: "สร้างเวลา",
    delOper: "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ให้บริการ",
    expireTime: "วันที่หมดอายุ",
    msgServer: "บริการเอสเอ็มเอส",
    agent: "ผู้ให้บริการเอสเอ็มเอส",
    pilot: "ซี.เอส.เอ็นเนอร์ยี่",
    operMsg: "ผู้ประกอบการเป็นเจ้าของ",
    signName: "ลายเซ็น SMS",
    agentPl: "กรุณาเลือกตัวแทน",
    signNamePl: "กรุณาใส่ลายเซ็น",
    please: "กรุณาป้อน",
    addOper: "ข้อมูลพื้นฐานของผู้ให้บริการ",
    operatorId: "รหัสองค์กร",
    operMax: "กรุณากรอกไม่เกิน 30 ตัวอักษร",
    companyNameMax: "ภายใน 10 ตัวอักษร",
    address: "ที่อยู่",
    addressPl: "กรุณากรอกรายละเอียดที่อยู่",
    region: "พื้นที่",
    addressPlCity: "โปรดเลือกภูมิภาค",
    description: "รายละเอียดบริษัท",
    contactPerson: "ติดต่อ",
    tel: "เบอร์ติดต่อ",
    serviceTel: "สายด่วนผู้บริโภค",
    contactsMail: "อีเมล์ติดต่อ",
    oprSystemName: "ชื่อระบบผู้ให้บริการ",
    oprSystemLogoFilePath: "โลโก้ระบบ",
    operTime: "ระยะเวลาดำเนินการ",
    activeTime: "เวลาที่มีประสิทธิภาพ",
    allTime: "ถาวร",
    add: "เพิ่มตัวดำเนินการ",
    updata: "ตัวดำเนินการอัปเดต",
    query: "ดูตัวดำเนินการ",
    rolePkIdPl: "โปรดเลือกบทบาทผู้ดำเนินการ",
    oprSystemLogoFilePathPl: "โปรดอัปโหลดโลโก้ระบบโอเปอเรเตอร์",
    qrCodeFilePathPl: "กรุณาอัปโหลดรหัส QR",
    mchCertFilePathPl: "โปรดอัปโหลดคำขอใบรับรองการคืนเงิน",
    logoPl: "กรุณาอัปโหลดโลโก้",
    activeTimePl: "กรุณาเลือกเวลาที่มีผล",
    zfbNamePl: "กรุณาใส่ลายเซ็น SMS",
    customTitle: "ฟังก์ชั่นที่กำหนดเอง",
    gunQrCodeType: "ลิงค์รหัส QR ของตะกร้อกองชาร์จ",
    gunQrCodeTypePl: "กรุณาเลือกประเภท",
    gunQrCodeType1: "การเชื่อมต่อโครงข่าย",
    gunQrCodeType2: "วิธีการเชื่อมโยงบัญชีสาธารณะ",
    gunQrCodeTypeTextP1:
      "1. หลังจากที่ตัวดำเนินการสร้างขึ้น ให้กำหนดค่าฟังก์ชันแบบกำหนดเองแยกกัน",
    gunQrCodeTypeTextP2:
      "2. โหมดการเชื่อมต่อเครือข่ายเริ่มต้นของรหัส QR ปากกระบอกปืน นั่นคือโหมดรหัส QR ปัจจุบัน",
    gunQrCodeTypeTextP3:
      "3. วิธีการเชื่อมโยงของบัญชีอย่างเป็นทางการคือการสแกนรหัส QR ของปากกระบอกปืนด้วยโหมดการเชื่อมโยงของบัญชีอย่างเป็นทางการ",
    accTime: "การวิเคราะห์การหมดอายุของบัญชี",
    loginInfo: "ข้อมูลการเข้าสู่ระบบของผู้ให้บริการ",
    loginUrl: "ข้อมูลเข้าสู่ระบบ",
    loginName: "เข้าสู่ระบบบัญชี",
    loginPasswd: "รหัสผ่านการเข้าใช้งาน",
    tips:
      "หมายเหตุ: โปรดบันทึกข้อมูลการเข้าสู่ระบบของคุณ หากคุณลืมรหัสผ่าน โปรดคลิกรีเซ็ต",
    resetPassword: "รีเซ็ตรหัสผ่าน",
    close: "ปิด",
    copy: "สำเนาด่วน",
    loginPassword: "รหัสผ่านการเข้าใช้งาน",
    iosAppDownloadLink: "ลิงค์ดาวน์โหลดแอพ IOS",
    androidAppDownloadLink: "ลิงค์ดาวน์โหลดแอป Android",
    website: "เว็บไซต์",
    creditPayment: "การชำระเงินเครดิต",
    valueAddedFeatures: "คุณสมบัติที่มีมูลค่าเพิ่ม",
    notificationMethodUser: "วิธีการแจ้งเตือนสำหรับผู้ใช้แต่ละราย",
    notificationMethodOperatorsser: "วิธีการแจ้งผู้ประกอบการ",
    passwordVerificationForOperatorModification:
      "การตรวจสอบรหัสผ่านการดำเนินการแก้ไขผู้ประกอบการ",
    registrationAndLoginConfiguration: "ลงทะเบียนการกำหนดค่าการเข้าสู่ระบบ",
    verificationMethod: "วิธีการยืนยัน (ลงทะเบียน/ลืมรหัสผ่าน/เปลี่ยนรหัสผ่าน)",
    registrationsSkipPasswordSetting:
      "การลงทะเบียนใหม่สามารถข้ามการตั้งค่ารหัสผ่านได้หรือไม่",
    passwordLoginMethod: "วิธีการเข้าสู่ระบบด้วยรหัสผ่าน",
    defaultLoginMethod: "วิธีการเข้าสู่ระบบเริ่มต้น",
    prioritySMS: "ข้อความลำดับความสำคัญ",
    priorityemail: "จดหมายสำคัญ",
    SMS: "SMS",
    email: "อีเมล",
    passwordVerification: "การยืนยันรหัสผ่าน",
    sMSVerification: "การยืนยันทาง SMS",
    sMSVerificationCode: "รหัสยืนยัน SMS",
    emailVerificationCode: "รหัสยืนยันอีเมล",
    phoneNumberPassword: "รหัสผ่านหมายเลขโทรศัพท์",
    emailPassword: "รหัสผ่านอีเมล",
    verificationCodeLogin: "การล็อกอินด้วยรหัสยืนยัน",
    PasswordLogin: "การล็อกอินด้วยรหัสผ่าน",
    rechargeCashier: "เคาน์เตอร์เติมเงิน",
    selfBuiltCashRegiste: "ระบบการชำระเงินที่สร้างเอง",
    hirdPartyCashRegister: "ระบบการชำระเงินผ่านบุคคลที่สาม",
    cash: "เงินสด",
    paymentChannel: "วิธีการชำระเงิน",
    paymentChannelPl: "โปรดเลือกวิธีการชำระเงิน",
    channelPartners: "พาร์ทเนอร์ช่องทาง",
    channelPartnersPl: "โปรดเลือกพาร์ทเนอร์ช่องทาง",
    plugAndCharge: "Plug & Charge"
  },

  operAccount: {
    reconciliation: "การกระทบยอดด้วยตนเอง",
    abnormalSum: "จำนวนข้อยกเว้น",
    result: "ผลการกระทบยอด",
    accDetails: "รายละเอียดบัญชี",
    details: "รายละเอียดการกระทบยอด",
    formula: "เปรียบเทียบบัญชี",
    abnormalReason: "รายละเอียดการเปรียบเทียบ",
    leftAmount: "เงินทางด้านซ้าย",
    rightAmount: "เงินด้านขวา",
    money: "ความแตกต่าง",
    accountType: "ประเภทบัญชี",
    accountPkId: "หมายเลขบัญชี",
    balanceAmount: "สมดุล",
    orderNo: "หมายเลขใบเรียกเก็บเงิน",
    orderNoPl: "โปรดป้อนหมายเลขคำสั่งเรียกเก็บเงิน",
    userCorrectAmount: "จำนวนเงินชดเชยบัญชีผู้ใช้ส่วนบุคคล",
    userCorrectAmountPl: "โปรดป้อนจำนวนเงินชดเชยบัญชีผู้ใช้ส่วนบุคคล",
    prepayCorrectAmount: "จำนวนเงินชดเชยบัญชี Escrow",
    prepayCorrectAmountPl: "โปรดป้อนจำนวนเงินชดเชยของบัญชีเอสโครว์",
    chargeCorrectAmount: "เรียกเก็บเงินชดเชยจำนวนเงินบัญชี",
    chargeCorrectAmountPl: "โปรดป้อนจำนวนเงินชดเชยบัญชีที่เรียกเก็บเงิน",
    password: "รหัสผ่านการทำงาน",
    passwordPl: "โปรดป้อนรหัสผ่านการดำเนินการ"
  },
  postNotice: {
    globalSearch: "ชื่อเรื่องที่คลุมเครือ",
    publish: "เผยแพร่",
    publishConfirm: "คุณแน่ใจหรือไม่ว่าต้องการเผยแพร่",
    withdraw: "ถอน",
    withdrawConfirm: "คุณแน่ใจหรือไม่ว่าต้องการถอน",
    title: "ชื่อ",
    titlePl: "กรุณาใส่ชื่อเรื่อง",
    content: "เนื้อหา",
    contentPl: "กรุณาใส่เนื้อหา",
    createTime: "เวลาในการสร้าง",
    publishTime: "เวลาปล่อย",
    publishStatus: "โพสต์สถานะ",
    email: "อีเมลแจ้งเตือน",
    emailPl: "กรุณาเลือกอีเมลแจ้งเตือน",
    open: "เปิด",
    close: "ปิด",
    add: "เพิ่มเผยแพร่",
    operPl: "โปรดเลือกผู้ให้บริการ",
    details: "เผยแพร่รายละเอียด",
    updata: "ปรับปรุง เผยแพร่"
  },
  auditHlhtSystem: {
    netDriection: "ทิศทางการเชื่อมต่อโครงข่าย",
    netStatus: "สถานะการอนุมัติ",
    globalSearch: "คำหลัก",
    netFileName: "ดาวน์โหลดเอกสารแนบ",
    audit: "การตรวจสอบ",
    auditModal: "ตรวจสอบการเชื่อมต่อโครงข่าย",
    yes: "ผ่าน",
    no: "ล้มเหลว",
    systemName: "ชื่อระบบ",
    reason: "เหตุผลในการสมัคร",
    netType: "ประเภทการทำงานระหว่างกัน",
    beginTime: "เวลาเริ่มต้น",
    endTime: "เวลาสิ้นสุด",
    contactName: "ติดต่อ",
    phoneNo: "โทรศัพท์"
  },
  addValueService: {
    serviceName: "ชื่อบริการ",
    logo: "โลโก้บริการ",
    hasOpen: "เปิดสถานะ",
    add: "เพิ่มบริการที่มีมูลค่าเพิ่ม",
    enable: "เปิดใช้งาน",
    disabled: "พิการ",
    logoPl: "กรุณาอัพโหลดไฟล์",
    hasOpenPl: "กรุณาเลือกสถานะ"
  },
  dataConfig: {
    tab1: "การกำหนดค่าค่าไฟฟ้า",
    tab2: "การกำหนดค่ารหัส QR",
    connectLoading: "กำลังเชื่อมต่อ.....",
    connectClose: "การเชื่อมต่อถูกขัดจังหวะหรือการเชื่อมต่อถูกปิด",
    reconnect: "เชื่อมต่อใหม่",
    realTimeMsg: "ข้อความตามเวลาจริง",
    clear: "ชัดเจน",
    gunPkIdPl: "กรุณาเลือกตะกร้อ",
    subscribeSuccess: "สมัครสมาชิกสำเร็จ",
    pilePkId: "หมายเลขกอง",
    pilePkIdPl: "กรุณาเลือกกอง",
    gunPkId: "หมายเลขปืน",
    ratedVoltage: "พิกัดแรงดันไฟฟ้า",
    ratedCurrent: "จัดอันดับปัจจุบัน",
    ratedPower: "กำลังอุปกรณ์",
    reply: "ตอบ",
    get: "รับ",
    pile: "กอง",
    platform: "แพลตฟอร์ม",
    pileData: "ข้อมูลกอง",
    platformData: "ข้อมูลแพลตฟอร์ม",
    rateName: "คิวอาร์โค้ด",
    rateNamePl: "โปรดป้อนสตริงรหัส QR",
    getBtn: "การทดสอบการเรียกคืน",
    issue: "ออกคิวอาร์โค้ด",
    send: "ส่ง",
    clickSend: "คลิกเพื่อส่ง",
    response: "การตอบสนอง",
    issueSuccess: "ออกเรียบร้อยแล้ว",
    ratePkid: "ประเมิน",
    rateTpl: "ชื่อเทมเพลตอัตรา",
    acRate: "อัตราเสาเข็ม AC",
    pileRate: "อัตรากอง",
    platformRate: "อัตราแพลตฟอร์ม",
    slotFlag: "ประเภทราคา",
    slotElecPrice: "ค่าไฟฟ้า (หยวน/กิโลวัตต์ชั่วโมง)",
    slotServicePrice: "ค่าบริการ (หยวน/กิโลวัตต์ชั่วโมง)",
    time: "ระยะเวลา"
  },
  chargingOperation: {
    status1: "ไม่ได้ใช้งาน",
    status2: "ใส่ปืน",
    status3: "เริ่มชาร์จ",
    status4: "กำลังชาร์จ",
    status5: "ปืนที่ถอดออกมา",
    tab1: "ข้อมูลรายงานการชาร์จ",
    tab2: "ข้อมูลการรายงาน BMS",
    tab3: "ข้อมูลรายงานการชาร์จ",
    startCharging: "เริ่มชาร์จ",
    msgType1: "เวลาจริง",
    msgType2: "ประวัติศาสตร์",
    time: "เวลาสื่อสาร",
    loadMore: "โหลดเพิ่มเติม"
  },
  operData: {
    58: "หมายเลขเวอร์ชันราคาต่อหน่วยแบบหลายอัตรา",
    100: "ระบบเครือข่าย",
    202: "อัปเกรดแพ็คเกจเวอร์ชัน",
    513: "ซิมการ์ด ICCID",
    1003: "ปิด/อนุญาตการชาร์จแบบออฟไลน์",
    1007: "กระแสไฟชาร์จสูงสุด",
    1009: "กำลังชาร์จสูงสุด",
    1010: "คิวอาร์โค้ด",
    2024: "ความแรงของสัญญาณซิมการ์ด",
    tab1: "เข้าสู่ระบบอุปกรณ์",
    tab2: "การเต้นของหัวใจของอุปกรณ์",
    tab3: "รายงานข้อผิดพลาด",
    tab4: "อัปเกรด",
    upgrade: "อัปเกรด",
    sendSuccess: "ส่งคำสั่งแล้ว ตรวจสอบสถานะอุปกรณ์",
    allow: "อนุญาต",
    prohibit: "ข้อห้าม",
    ethernet: "อีเธอร์เน็ต",
    host: "ที่อยู่ IP ของโฮสต์",
    port: "พอร์ตโฮสต์",
    userName: "ชื่อผู้ใช้ FTP",
    password: "รหัสผ่านผู้ใช้ FTP",
    fileDir: "ไดเร็กทอรีไฟล์",
    success: "อัปเดตสำเร็จ"
  },
  messageManage: {
    msgTitle: "กลุ่ม SMS",
    rechange: "เปลี่ยน",
    remaining: "จำนวนคงเหลือ",
    used: "จำนวนแท่งที่ใช้ (แท่ง)",
    top5: "ที่เหลืออยู่top5",
    unit: "แถบ",
    remainingMin: "นาทีที่เหลือ",
    remainingMax: "เหลือสูงสุด",
    usedMin: "นาทีที่ใช้",
    usedMax: "ใช้สูงสุด",
    recordBtn: "บันทึก SMS",
    rechargeBtn: "SMS เติมเงิน",
    totalNum: "ซื้อแล้ว",
    sentNum: "บาร์ที่ใช้แล้ว",
    addNum: "เพิ่ม SMS",
    remainNum: "ข้อความที่เหลืออยู่",
    comboPkId: "ซื้อ SMS",
    paymentAmount: "ยอดชำระ",
    msgRechange: "SMS เติมเงิน",
    comboPkIdPl: "กรุณาเลือกจำนวน SMS"
  },
  messageRecord: {
    tab1: "บันทึกการซื้อ",
    tab2: "ส่งบันทึก",
    pkid: "หมายเลขคำสั่งซื้อ",
    purchasedWay: "ช่องทางการซื้อ",
    auditStatus: "สถานะการสั่งซื้อ",
    attachmentUrl: "ภาคผนวก",
    downloadAttachmentUrl: "ดาวน์โหลด",
    audit: "การตรวจสอบ",
    createUserName: "ผู้ประกอบการ",
    purchasedCount: "ปริมาณการซื้อ",
    paymentAmount: "ยอดชำระ",
    createTime: "เวลาซื้อ",
    phoneNo: "โทรศัพท์",
    agent: "ส่งประเภท",
    bussType: "ประเภทธุรกิจ",
    pilot: "ซี.เอส.เอ็นเนอร์ยี่",
    aliCloud: "อาลี คลาวด์",
    sendTime: "ส่งเวลา",
    content: "ส่งเนื้อหา",
    status: "ส่งสถานะ",
    auditAction: "สถานะการอนุมัติ",
    oprSystemLogoFilePath: "อัปโหลดไฟล์แนบ",
    msgAudit: "การตรวจสอบ SMS",
    auditActionPl: "โปรดเลือกสถานะการตรวจสอบ",
    oprSystemLogoFilePathPl: "โปรดอัปโหลดไฟล์แนบ",
    auditAction1: "ผ่าน",
    auditAction2: "ปฏิเสธ"
  },
  messagePrice: {
    number: "จำนวน SMS",
    price: "ราคาแพ็คเกจ",
    contactPhone: "เบอร์โทรศัพท์ติดต่อ",
    status: "สถานะ",
    rechargeContact: "ติดต่อเติมเงิน",
    rechargeTips:
      "การแก้ไขข้อมูลการติดต่อจะเป็นการแก้ไขข้อมูลติดต่อของแพ็คเกจ SMS อื่นพร้อมกัน โปรดแก้ไขด้วยความระมัดระวัง",
    qrCodeFilePkId: "ติดต่อวีแชท",
    qrCodeFilePkIdTips: "อัปโหลดรหัส QR รองรับ .jpg .jpeg .png",
    qrCodeFilePkIdPl: "โปรดอัปโหลดรายชื่อผู้ติดต่อ WeChat",
    updata: "แก้ไขราคา",
    add: "เพิ่มราคา",
    close: "ปิด",
    closeConfirm: "คุณแน่ใจหรือว่าจะปิด?"
  },
  cardClient: {
    projectName: "ชื่อโครงการ",
    updataTime: "เวลาอัปเดต",
    queryCode: "ดูรหัสลูกค้า",
    licenseBtn: "การจัดการใบอนุญาต",
    createUserName: "ผู้สร้าง",
    activatedAmount: "จำนวนที่เปิดใช้งาน",
    projectCode: "รหัสลูกค้า",
    modifyTime: "ดาวน์โหลดไฟล์ใบอนุญาต",
    moduleNames: "โมดูลใบอนุญาต",
    machineCode: "หมายเลขซีเรียล",
    pileNumber: "จำนวนกอง",
    status: "สถานะ",
    beginTime: "วันที่มีผล",
    endTime: "วันที่หมดอายุ",
    add: "เพิ่มรายการ",
    projectNamePl: "กรุณาใส่ชื่อโครงการ",
    projectCodeMax: "รหัสลูกค้าต้องเป็น 8 หลัก",
    modulePkIdsPl: "โปรดเลือกโมดูลใบอนุญาต",
    machineCodePl: "กรุณาใส่หมายเลขซีเรียล",
    beginTimePl: "โปรดเลือกวันที่มีผลบังคับใช้",
    endTimePl: "กรุณาเลือกวันหมดอายุ",
    addLicence: "เพิ่มใบอนุญาต",
    updataLicence: "ปรับปรุงใบอนุญาต",
    timeMax: "วันที่มีผลบังคับใช้ต้องไม่เกินวันหมดอายุ"
  },
  simOutTest: {
    projectName: "ชื่อโครงการ",
    keywords: "คำหลัก",
    pileNoOrIccidPl: "รหัสอุปกรณ์/ICCID",
    applicantOrCaller: "ผู้เรียกร้อง/ผู้โทร",
    simStatus: "สถานะซิมการ์ด",
    createTime: "เวลาในการสร้าง",
    recallTest: "การทดสอบซิมการ์ด",
    claim: "แอปพลิเคชันซิมการ์ด",
    batchSync: "การซิงค์เป็นชุด",
    sync: "ซิงโครไนซ์",
    applicant: "ผู้เรียกร้อง",
    caller: "โทรทดสอบ",
    outgoer: "ผู้ขาย",
    modifyTime: "เวลาอัปเดต",
    simStatusPl: "โปรดเลือกสถานะซิมการ์ด",
    serialNumber: "รหัสอุปกรณ์",
    applyTitle: "สมัครซิมการ์ด",
    iccid: "หมายเลขซิมการ์ด",
    iccidTips: "กรุณาป้อน จำกัด 100 ตัวอักษร",
    importFile: "นำเข้าไฟล์",
    downloadTpl: "ดาวน์โหลดเทมเพลต",
    simSum: "จำนวนซิมการ์ด",
    applicantPl: "โปรดป้อนผู้อ้างสิทธิ์",
    iccidPl: "กรุณากรอกหมายเลขซิมการ์ด",
    outgoerPl: "กรุณาใส่ชื่อผู้ส่ง",
    snStartNo: "ป้อนหมายเลขเริ่มต้น",
    snEndNo: "ใส่เลขท้าย",
    match: "จับคู่",
    projectNamePkId: "โครงการที่เกี่ยวข้อง",
    saveExport: "บันทึกและส่งออก",
    modalTitle: "การทดสอบซิมการ์ด"
  },
  productionOrder: {
    step0: "กระบวนการเริ่มต้น",
    step1: "ขั้นแรก",
    step2: "ขั้นตอนที่สอง",
    step3: "ขั้นตอนที่สาม",
    step4: "กระบวนการสิ้นสุดลง",
    content0: "เพิ่มรายการงาน",
    content1: "เริ่มการผลิต",
    content2: "ที่เก็บอุปกรณ์",
    content3: "การตรวจสอบคุณภาพ",
    content4: "จัดส่งอุปกรณ์",
    keyword: "คำหลัก",
    numOrProject: "เลขที่สัญญา/ชื่อโครงการ",
    modelName: "รุ่นอุปกรณ์",
    productionStatus: "สถานะการผลิต",
    createTime: "วันที่สร้าง",
    syncDev: "อุปกรณ์ซิงค์",
    start: "เริ่มการผลิต",
    void: "เป็นโมฆะ",
    changePriority: "ปรับลำดับความสำคัญ",
    warehousing: "ที่เก็บอุปกรณ์",
    check: "ตรวจสอบคุณภาพ",
    ship: "จัดส่งอุปกรณ์",
    index: "หมายเลขซีเรียล",
    priority: "ลำดับความสำคัญ",
    orderType: "ประเภทใบสั่งงาน",
    contractBillNumber: "เลขที่สัญญา",
    projectName: "ชื่อโครงการ",
    platformModel: "โมเดลแพลตฟอร์ม",
    pileNum: "ปริมาณอุปกรณ์",
    doneModelNum: "จัดส่ง",
    warehousingConfirm: "แน่ใจหรือว่าต้องการตุน??",
    delConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบใบสั่งผลิตนี้",
    voidConfirm: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกใบสั่งผลิต??",
    startConfirm: "คุณแน่ใจหรือว่าต้องการเริ่มการผลิต??",
    projectInfo: "ข้อมูลโครงการ",
    contractBillNumberPl: "กรุณาเลือกเลขที่สัญญา",
    priorityPl: "โปรดเลือกลำดับความสำคัญ",
    projectNamePl: "กรุณาเลือกชื่อโครงการ",
    devInfo: "ข้อมูลอุปกรณ์",
    materialNumber: "รหัสวัสดุ",
    materialNumberPl: "กรุณากรอกรหัสสินค้าสำเร็จรูป",
    clientNum: "รหัสลูกค้า",
    clientNumPl: "กรุณากรอกรหัสลูกค้า",
    deviceModelPkId: "รุ่นอุปกรณ์",
    deviceModelPkIdPl: "กรุณาเลือกรุ่นอุปกรณ์",
    platformModelPl: "กรุณาเลือกรูปแบบแพลตฟอร์ม",
    deviceNo: "รหัสอุปกรณ์",
    deviceStartNo: "เริ่มต้นหมายเลขอุปกรณ์",
    deviceEndNo: "หมายเลขเครื่องปลายทาง",
    quantity: "ปริมาณอุปกรณ์",
    motherboard: "เมนบอร์ด",
    motherboardPl: "กรุณาใส่เมนบอร์ด",
    interfaceBoard: "รุ่นอินเทอร์เฟซ",
    interfaceBoardPl: "โปรดป้อนเวอร์ชันอินเทอร์เฟซ",
    displayScreen: "แสดง",
    displayScreenPl: "กรุณาใส่จอแสดงผล",
    requirements: "ข้อกำหนดการปรับแต่งและการผลิต",
    requirementsPl: "โปรดป้อนข้อกำหนดที่กำหนดเองและการผลิต",
    inputMaxPl: "กรุณาป้อน จำกัด 100 ตัวอักษร",
    equipmentRemarks: "หมายเหตุอุปกรณ์",
    equipmentRemarksPl: "โปรดป้อนข้อสังเกตของอุปกรณ์",
    adds: "ให้เพิ่ม",
    issuerAndCard: "ผู้ออกบัตร + บัตร IC",
    issuerAndCardPl: "กรุณากรอกผู้ออกบัตร + บัตร IC",
    remark: "ข้อสังเกตรายการงาน",
    remarkPl: "โปรดป้อนบันทึกงาน",
    verificationInfo: "ข้อมูลการตรวจสอบ",
    verifier: "สารวัตร",
    checkContent: "ตรวจสอบเนื้อหา",
    shippingInfo: "ข้อมูลการจัดส่ง",
    deliveryRequirements: "ข้อกำหนดในการจัดส่ง",
    logisticsAndNumber: "โลจิสติกส์และหมายเลขติดตาม",
    inspectionAndSignature: "ลายเซ็นตรวจสอบและตรวจสอบการจัดส่ง",
    shippingCardIssuerICCard: "ผู้ออกบัตร + บัตร IC",
    shippingCardIssuerICCardPl: "กรุณากรอกผู้ออกบัตร + บัตร IC",
    orderTypePl: "กรุณาเลือกประเภทคำสั่งงาน",
    add: "เพิ่มรายการงาน",
    updata: "แก้ไขรายการงาน",
    details: "รายละเอียดการสั่งงาน",
    other: "ข้อมูลอื่น ๆ",
    deliveryRequirementsPl: "กรุณาป้อนคำขอจัดส่ง",
    logisticsAndNumberPl: "กรุณาใส่หมายเลขขนส่งและหมายเลขติดตาม",
    inspectionAndSignaturePl:
      "โปรดป้อนลายเซ็นสำหรับการตรวจสอบและการตรวจสอบการจัดส่ง",
    verifierPl: "กรุณาใส่เครื่องยืนยัน",
    checkContentPl: "โปรดป้อนเนื้อหาการตรวจสอบ"
  },
  salesOrder: {
    globalSearch: "เลขที่สัญญา/ชื่อโครงการ/พนักงานขาย",
    sellerName: "ผู้ขาย",
    specificationModel: "ข้อมูลจำเพาะ",
    month: "การจัดส่งโดยประมาณ",
    monthPl: "กรุณาเลือกการจัดส่งโดยประมาณ",
    deliveryTime: "เวลาการส่งมอบ",
    shipConfirm: "คุณแน่ใจหรือไม่ว่าต้องการจัดส่ง",
    childTitle: "รายการย่อย - ข้อมูลผลิตภัณฑ์",
    number: "ปริมาณ",
    requirementDesc: "คำอธิบายข้อกำหนด",
    requirementDescPl: "กรุณากรอกรายละเอียดความต้องการ",
    shippingAddress: "ที่อยู่สำหรับการจัดส่ง",
    shippingAddressPl: "กรุณากรอกที่อยู่ในการจัดส่ง",
    add: "เพิ่มใบสั่งขาย",
    contractBillNumberPl: "กรุณากรอกเลขที่สัญญา",
    specificationDetails: "ข้อมูลจำเพาะ",
    specificationDetailsPl: "กรุณาป้อนข้อมูลจำเพาะ",
    sellerNamePl: "กรุณากรอกพนักงานขาย",
    month1: "มกราคม",
    month2: "กุมภาพันธ์",
    month3: "มีนาคม",
    month4: "เมษายน",
    month5: "อาจ",
    month6: "มิถุนายน",
    month7: "กรกฎาคม",
    month8: "สิงหาคม",
    month9: "กันยายน",
    month10: "ตุลาคม",
    month11: "พฤศจิกายน",
    month12: "ธันวาคม"
  },
  header: {
    clickGo: "คลิกเพื่อกระโดด",
    out: "ออกจากระบบ",
    outConfirm: "คุณแน่ใจว่าคุณต้องการที่จะออกจากระบบ?",
    unit: ""
  },
  reportFile: {
    pageTitle: "ไฟล์รายงาน",
    deviceArchivePkId: "รหัสไฟล์",
    deviceTypeName: "ประเภทอุปกรณ์",
    manufacturerName: "ผู้ผลิต",
    deviceModelName: "รุ่นอุปกรณ์",
    deviceModelRatedPower: "กำลังไฟ",
    deviceModelChargeStandardName: "มาตรฐานอุปกรณ์",
    archiveCode: "รายงานฉบับที่",
    feelerMechanismName: "หน่วยงานทดสอบ",
    archiveCreateDate: "วันที่สร้างรายงาน",
    attachmentRecordPkId: "พิมพ์รายงานการทดสอบ",
    entryDate: "วันที่เข้า",
    deviceRatedPower: "ช่วงพลังงาน (กิโลวัตต์)",
    query: "คลิกเพื่อดู",
    change: "รายงานการเปลี่ยนแปลง",
    updataTitle: "กรุณาเลือกไฟล์",
    minDeviceRatedPowerError: "ค่าต่ำสุดของช่วงพลังงานต้องไม่น้อยกว่า 0",
    maxDeviceRatedPowerError: "ค่าสูงสุดของช่วงพลังงานต้องไม่น้อยกว่า 0",
    minMaxDeviceRatedPowerError:
      "ค่าสูงสุดของช่วงพลังงานต้องไม่ต่ำกว่าค่าต่ำสุด"
  },
  siteSizeConfig: {
    smallSizeStaNum: "ขนาดเล็ก",
    mediumSizeStaNum: "ขนาดกลาง",
    largeSizeStatNum: "ขนาดใหญ่",
    configName: "ชื่อการกำหนดค่า",
    pileNum: "จำนวนเสาเข็ม (ชุด)",
    power: "กำลังไฟ (กิโลวัตต์)",
    min: "น้อยกว่า",
    max: "มากกว่า",
    updataTitle: "แก้ไขการกำหนดค่าขนาดไซต์",
    maxTips: "ค่าสูงสุดต้องไม่น้อยกว่า:",
    maxPile: "ค่าสูงสุดของกอง",
    minPile: "มูลค่าขั้นต่ำของกอง",
    maxPower: "กำลังไฟสูงสุด",
    minPower: "พลังงานขั้นต่ำ"
  },
  appUpdate: {
    addUpgradeReminder: "เพิ่มการแจ้งเตือนการอัปเกรด",
    editUpgradeReminder: "แก้ไขการแจ้งเตือนการอัปเกรด",
    operatorNameAbbreviation: "ชื่อ/ชื่อย่อผู้ประกอบการ",
    type: "ประเภท",
    status: "สถานะ",
    upgradeCopy: "ข้อความอัพเกรด",
    thaiLanguage: "ภาษาไทย",
    english: "ภาษาอังกฤษ",
    chinese: "ภาษาจีน",
    inValidContent: "การดำเนินการต่อจะทำให้กฎนี้ไม่มีผลหรือไม่?",
    msg: {
      error:
        "มีกฎของผู้ประกอบการประเภทเดียวกันที่กำลังมีผลอยู่ กรุณาทำให้กฎเดิมไม่มีผลก่อน"
    },
    table: {
      compatibleOperator: "ผู้ประกอบการที่เข้ากันได้",
      type: "ประเภท",
      mandatoryUpgradeVersion: "เวอร์ชันที่ต้องอัพเกรดอย่างจำเป็น",
      remindUpgradeVersion: "เวอร์ชันเตือนการอัพเกรด",
      remarks: "หมายเหตุ",
      updateTime: "เวลาอัพเดต",
      status: "สถานะ",
      operation: "การดำเนินการ",
      addUpgradeNotification: "เพิ่มการแจ้งเตือนการอัพเกรด",
      effective: "มีผล",
      ineffective: "ไม่มีผล",
      pendingActivation: "รอการมีผล"
    },
    rules: {
      appType: "โปรดเลือกประเภทโทรศัพท์",
      oprType: "โปรดเลือกผู้ประกอบการ",
      remindUpgradeVersion: "กรุณาใส่เวอร์ชันเตือนการอัพเกรด"
    }
  },
  paymentChannel: "วิธีการชำระเงิน",
  car: {
    addModel: {
      addTitle: "เพิ่มรถยนต์",
      editTitle: "แก้ไขรถยนต์"
    },
    tips: {
      brandTips: "ต้องการแบรนด์",
      serialTips: "ต้องการหมายเลขซีเรียล",
      modelTips: "ต้องการรุ่น",
      fuelTypeTips: "ต้องการประเภทเชื้อเพลิง"
    },
    operator: "โอเปอเรเตอร์",
    timeSubmitted: "เวลาที่ส่ง",
    carDirectory: "ไดเรกทอรีรถยนต์",
    userFeedback: "ข้อเสนอแนะจากผู้ใช้",
    brand: "ยี่ห้อ",
    series: "ซีรีส์",
    model: "รุ่น",
    region: "ภูมิภาค",
    powerMode: "โหมดพลังงาน",
    rank: "ระดับ",
    type: "ประเภท",
    seats: "ที่นั่ง",
    batteryCapacity: "ความจุแบตเตอรี่ (กิโลวัตต์ชั่วโมง)",
    mileage: "เลขไมล์ (กม.)",
    createDate: "วันที่สร้าง",
    users: "จำนวนผู้ใช้",
    inputLimitDescription: "สามารถป้อนได้สูงสุด 4 หลัก ทศนิยมคงไว้ 2 ตำแหน่ง",
    inputPositiveInteger6DigitsMax: "กรุณาป้อนเลขจำนวนเต็มบวกไม่เกิน 6 หลัก",
    globalSearch: "กรอกหมายเลขรุ่นรถยนต์"
  },
  countrycode: {
    add: "เพิ่มรหัสพื้นที่",
    edit: "แก้ไขรหัสพื้นที่",
    areaCode: "รหัสพื้นที่",
    enName: "ชื่ออังกฤษ",
    zhName: "ชื่อจีน",
    locName: "ชื่อภาษาท้องถิ่น",
    regRules: "กฎสำหรับตรวจสอบนิพจน์ปกติ",
    regRulesPl: "โปรดป้อนกฎสำหรับตรวจสอบนิพจน์ปกติ",
    regRulesPl1: "โปรดป้อนกฎสำหรับตรวจสอบนิพจน์ปกติที่ถูกต้อง"
  }
};
